<div class="dashboard-container">
	<img #img class="img-fluid" src="assets/images/logos/logo_transparent.png" />
</div>
